import api from "./api";

export const filterService = {
  fetchDistinctValues: async (fieldName, clientId) => {
    const response = await api.post("api/filters/fetch-distinct-values", {
      filter_for: fieldName,
      client_id: clientId,
    });
    return response.data;
  },
};
